"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapProductBoxProps = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _models = require("../../models");
var _utils = require("../../utils");
var _internal = require("../../utils/internal");
var _mapCanBeSubscribed = require("../mapCanBeSubscribed");
var _mapLabels = require("../mapLabels");
var _mapShades = require("../mapShades");
var _mapShowQuickBuyButton = require("../mapShowQuickBuyButton");
const mapProductBoxProps = ({
  data,
  overrides,
  mode = _models.ProductBoxMode.Concept,
  isAnonymousUser,
  logger
}) => {
  const {
    backInStockAvailability,
    concept,
    externalPicking,
    formattedPrice,
    imageUrl,
    isOffStock,
    labels,
    mainImage,
    productCode,
    subscription
  } = data;
  const name = concept?.name;
  const shades = (0, _mapShades.mapShades)(concept?.products);
  const isMultiShade = Boolean((0, _internal.isMultiShadeProduct)({
    shades
  }));
  const hasAutoSubscription = (0, _mapCanBeSubscribed.mapCanBeSubscribed)(labels);
  if (!concept || !name) {
    (0, _internal.logMissingConceptOrName)({
      logger,
      data
    });
    return null;
  }
  return (0, _deepmerge.default)({
    brand: concept.brand?.name ?? null,
    buttons: {
      favorites: {
        trigger: isMultiShade && mode === _models.ProductBoxMode.Concept && !isAnonymousUser,
        visible: true
      },
      notifyMe: {
        trigger: isMultiShade,
        visible: Boolean(backInStockAvailability?.showBackInStockNotification)
      },
      quickBuy: {
        trigger: (isMultiShade || hasAutoSubscription) && mode === _models.ProductBoxMode.Concept,
        visible: (0, _mapShowQuickBuyButton.mapShowQuickBuyButton)(labels)
      }
    },
    lowerImageOpacity: !(0, _mapShowQuickBuyButton.mapShowQuickBuyButton)(labels) && !(externalPicking && isOffStock),
    code: productCode ?? '',
    image: mainImage?.url ?? imageUrl ?? null,
    imageAlt: mainImage?.altText ?? null,
    isLink: true,
    labels: (0, _mapLabels.mapLabels)(labels),
    name,
    price: {
      currentFormatted: (0, _utils.getCurrentFormattedPrice)({
        formattedPrice
      }),
      old: (0, _utils.getOldPrice)({
        formattedPrice
      }),
      previousMinOffer: formattedPrice?.price?.previousMinOfferPrice ?? null
    },
    rating: concept.ratingAverage ?? 0,
    ratingCount: concept.ratingCount ?? 0,
    shades,
    url: (0, _internal.getProductUrl)(productCode ?? ''),
    hasAutoSubscription,
    isMultiShade,
    mode,
    subscription: {
      available: subscription?.available ?? false
    }
  }, overrides ?? {});
};
exports.mapProductBoxProps = mapProductBoxProps;
//# sourceMappingURL=mapProductBoxProps.js.map